import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { TextAreaField } from "@/components/ui/form/fields/text-area-field";

type Props = {
	description: ForNodeType<string>;
	onSetDescription: (input: string) => void;

	title?: string;
	guide?: string;
};

export const QuestionOptionDescription = ({ description, onSetDescription, title: _title, guide: _guide }: Props) => {
	const title = _title ?? "オプションの紹介文";
	const guide = _guide ?? "オプションの魅力を伝える紹介文を書きましょう。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={true}
			title={title}
			guide={guide}
			isEdited={description.isEdited}
			hasError={Boolean(description.error)}
			inputChildren={
				<TextAreaField
					errorMessage={description.error}
					value={description.value}
					handleChange={onSetDescription}
				/>
			}
		/>
	);
};

QuestionOptionDescription.displayName = "QuestionOptionDescription";
